import {observable} from 'mobx';
import {construct, createInstance, ModelProperties} from 'utils';
import {WebLocaleKey} from './web-locale-key';
import {Language} from './language';

export class WebLocaleContent {
    @observable id!: number;

    @observable contentEdited: string = '';

    @observable contentVerified: string = '';

    @observable verified: boolean = false;

    @observable outdated: boolean = false;

    @observable keyId!: number;

    @observable languageId!: number;

    @observable key?: WebLocaleKey;

    @observable language?: Language;

    constructor(content?: ModelProperties<WebLocaleContent>) {
        if (content) {
            construct(this, content);
            this.key = createInstance(WebLocaleKey, content.key);
            this.language = createInstance(Language, content.language);
        }
    }
}